@if(viewFlags.isCartOpen()) {
  <noda-shadow
    *nodaResponsiveIf="[enMaxWidthScreen.SM]"
    [contentCenter]="false"
  />
}

@if (counter() > 0 && !viewFlags.isCartOpen()) {
<noda-cart-open-button
  [arrowTemplateRef]="svgArrowTemplateRef"
  [counter]="counter()"
  (clicked)="toggleCart()"
/>
}

@if (viewFlags.isCartOpen()) {
  <noda-cart-content
    [arrowTemplateRef]="svgArrowTemplateRef"
    (productToggleClicked)="onProductToggle($event)"
    (startClicked)="onStartClick()"
    (toggleClicked)="toggleCart()"
  />
}

<ng-template #svgArrowTemplateRef>
  <div class="arrow-wrapper">
    <svg-icon
      name="icons/icon-double-arrow.svg#iconDoubleArrow"
      class="icon-arrow"
    />
  </div>
</ng-template>
